import React from 'react';
import StudentLayout from '../components/StudentLayout';

export default function AcademicCalendar() {
  return (
    <StudentLayout title="Academic Calendar">
      <h2>Academic Calendar</h2>
      <p>Academic calendar details will appear here.</p>
    </StudentLayout>
  );
}
